import { Center, Stack } from '@mantine/core';
import { PreviewHeader, PreviewOption } from '@/app/components/shared/viewer/PreviewHeader';
import TurnTable from './TurnTable';
import { Viewer } from '@/app/components/shared/viewer/Viewer';
import Image from 'next/image';

export interface StripImage {
  title: string;
  src: string;
  posX?: number;
}

interface AssetPreviewProps {
  previewConfig: string;
  tab: PreviewOption;
  onTabChanged: (option: PreviewOption) => void;
  images: StripImage[];
  previewHeight?: number;
  glbUrl?: string;
  isLarge: boolean;
}

export function AssetPreview({
  tab,
  onTabChanged,
  images,
  previewConfig,
  previewHeight,
  glbUrl,
  isLarge,
}: AssetPreviewProps) {
  const height = Math.max(previewHeight ?? 0, 500);

  return (
    <Stack gap='xs'>
      <PreviewHeader selected={tab} onChanged={onTabChanged} is3dAvailable={!!glbUrl} />
      {tab === 'gallery' && <TurnTable images={images} height={height} />}
      {tab === '3d' && glbUrl && (
        <Viewer assetUrl={glbUrl} customisationJson={previewConfig} height={height} isLarge={isLarge} />
      )}
    </Stack>
  );
}
